import { alpha } from "@mui/material";
import { makeStyles } from "@mui/styles";
export const useMyMealsStyles = (props) => {
    const classes = makeStyles((theme) => ({
        "@global": {
            '[id^="mui"] .MuiTooltip-tooltip': {
                background: theme.palette.primary.light,
                opacity: "0.9",
                maxWidth: "250px",
                fontSize: "0.8em",
            },
            "[id^='mui'] .MuiTooltip-arrow": {
                color: theme.palette.primary.main,
            },
            ".slick-prev::before, .slick-next::before": {
                color: theme.palette.primary.main,
            },
            ".meal-type-title": {
                color: theme.palette.primary.main,
            },
            ".meal-type-edit-meal": {
                color: theme.palette.primary.main,
            },
            ".meal-type-edit-meal-border": {
                color: theme.palette.primary.main,
                border: `2px solid ${theme.palette.primary.main}`,
            },
            ".react-multi-carousel-item": {
                display: "flex",
            },
        },
        mealDayHeader: {
            display: "flex",
            flexDirection: "column",
            margin: "5px",
            width: "95%",
            borderRadius: "10px",
            textTransform: "none",
            lineHeight: "normal",
            justifyContent: "flex-start",
            "& .message": {
                marginTop: "10px",
                height: "30px",
            },
        },
        mealDayHeaderMobile: {
            width: "90%",
            "& .message": {
                marginTop: "0px",
            },
        },
        dropdownLink: {
            "& a": {
                textDecoration: "none",
            },
            "&.active": {
                backgroundColor: theme.palette.primary.main,
            },
            "&:hover:not(.active)": {
                backgroundColor: alpha(theme.palette.primary.light, 0.1),
            },
        },
        editMealDialog: {
            "& .mm-edit-meal-confirm-button:not([disabled])": {
                color: "#fff",
                background: theme.palette.secondary.main,
            },
        },
        cartButtonContainer: {
            right: 4,
            position: "fixed",
            "&.is-scrolling": {
                visibility: "hidden !important",
                opacity: "0 !important",
                transition: "opacity 0.2s !important",
            },
        },
        cartButton: {
            "&:hover": {
                background: theme.palette.primary.main,
                color: "#fff",
                "& i": {
                    color: "#fff",
                },
                "& span": {
                    color: "#fff",
                },
                "& path": {
                    color: "#fff",
                },
            },
            "&:not(:hover)": {
                "& i": {
                    color: theme.palette.primary.main,
                },
                "& span": {
                    color: theme.palette.primary.main,
                },
                "& path": {
                    fill: theme.palette.primary.main,
                },
            },
        },
        cartContinueButton: {
            background: theme.palette.primary.main,
            color: "#fff",
            "&:not(.inactive):hover": {
                color: theme.palette.primary.main,
            },
        },
        tabs: {
            "& button[aria-selected='true']": {
                borderBottom: `2px solid ${theme.palette.primary.main}`,
            },
        },
        tabsIndicator: {
            background: "none",
        },
        customIconWrapper: (props) => ({
            backgroundColor: props.isIconWhite ? theme.palette.primary.main : undefined,
            padding: theme.spacing(0.5),
            lineHeight: 1,
            borderRadius: theme.shape.borderRadius,
        }),
        // This style overrides styles set in styles.css, therefore !important is necessary
        mobileCartButtonBottom: (props) => ({
            "@media screen and (max-width: 600px)": {
                bottom: `${theme.spacing(0.5)}px !important`,
                position: "sticky",
                marginLeft: "auto",
                // Necessary to give some padding between the footer and cartButton
                marginBottom: "4px !important",
            },
        }),
    }));
    return {
        classes: classes(props),
    };
};
